// extracted by mini-css-extract-plugin
module.exports = {"leftCTA":"NavigationDrawer_leftCTA__eAYVn","rightCTA":"NavigationDrawer_rightCTA__1G5B9","centerVertically":"NavigationDrawer_centerVertically__fbLww"};